<script>
// import Swal from "sweetalert2";
import Layout from "../../layouts/main";
import appConfig from "../../../app.config";
import Basic from "@/views/work-order/components/basic";
import DeviceInfo from "@/views/work-order/components/device-info";
import Logs from "@/views/work-order/components/logs";
// import Report from "@/views/work-order/components/report";
import {editWorkOrder, workOrderDetail, getRepairDetail, patchOpportunity, postOpportunityComment} from "@/service";
import {formatDatetime, toUtcFormat, getLabel} from "@/helpers/common";
import WoStatusEtc from "@/views/work-order/components/widgets/wo-status-etc";
import {alertComfirm,errorMsg} from "@/helpers/swal";
import ReportList from "@/views/service-report/components/report-list";
import _ from "lodash";
import {
  WO_STATUS_TO_BE_ASSIGNED,
  WO_STATUS_TO_BE_CONSTRUCTED,
  WO_STATUS_COMPLETED,
  WO_STATUS_CANCELLED, BUSINESS_DELAY_REASON,
} from "@/config/common";
import {
  isWorkOrderToBeConfirmed,
  isWorkOrderUnderConstruction,
} from "@/views/work-order/wo-status-op";
import moment from "moment";
import CancelModal from "@/views/work-order/components/widgets/cancel-modal";

export default {
  page: {
    // title: "工单",
    meta: [{
      name: "description",
      content: appConfig.description,
    }]
  },
  data() {
    return {
      WO_STATUS_CANCELLED,
      workOrderId: null,
      detailLoaded: false,
      woData: {},
      checkTabVal: '1',
      tabOptions: [
        {
          value: '1',
          text: this.$t('page.basic-info')
        },
        {
          value: '2',
          text: this.$t('page.equipment-info')
        },
        {
          value: '3',
          text: this.$t('page.service-report.text')
        },
        // {
        //   value: '4',
        //   text: '工单日志'
        // }
      ],
      deviceImg: null,
      checkins: [],
      cancelOrderObj: {
        show: false,
        title: this.$t('page.cancel_order'),
        // 如果是商机转工单，需要显示取消原因
        showCancelReason: false,
        cancelReasonRequired: false,
        cancelReasonList: [
          ...BUSINESS_DELAY_REASON
        ],
        type:''
      },
    }
  },
  mounted() {
    this.workOrderId = this.$route.params.id
    this.getDetail()
  },
  computed: {
    showCancelBtn() {
      return [WO_STATUS_TO_BE_ASSIGNED, WO_STATUS_TO_BE_CONSTRUCTED].includes(parseInt(this.woData.status))
    },
    showTransferBtn() {
      if (isWorkOrderToBeConfirmed(this.woData)) {
        return true
      }
      return false
    },
    showConfirmBtn() {
      if (isWorkOrderToBeConfirmed(this.woData)) {
        return true
      }
      return false
    },
    showCompleteBtn() {
      if (isWorkOrderUnderConstruction(this.woData)) {
        return true
      }
      return false
    }
  },
  methods: {
    formatDatetime,
    getLabel,
    getDetail() {

      workOrderDetail(this.workOrderId).then(res => {
        this.woData = res.payload
        // 如果是服务请求转工单，查询请求信息
        if (this.woData.service_request) {
          getRepairDetail(this.woData.service_request).then(serviceRes => {
            this.woData.serviceRequestData = serviceRes.payload
            this.detailLoaded = true
          })
        } else {
          this.detailLoaded = true
        }
      }).catch(err => {
        console.log(err)
      })
    },
    refresh () {
      this.getDetail()
    },
    checkinLoaded(checkins) {
      this.checkins = checkins
    },
    deviceLoaded(deviceInfo) {
      const imgs = _.get(deviceInfo, 'files.image', [])
      if (imgs.length > 0) {
        this.deviceImg = imgs[0].url
      } else {
        this.deviceImg = null
      }
    },
    // 取消工单
    cancelOrder() {
      this.cancelOrderObj.show = true
      if (this.woData.task_id) {
        this.cancelOrderObj.showCancelReason = true
        this.cancelOrderObj.cancelReasonRequired = true
        this.cancelOrderObj.type = 'task' //商机转化

      } else {
        this.cancelOrderObj.showCancelReason = false
        this.cancelOrderObj.cancelReasonRequired = false
      }

      // this.cancelOrderObj = JSON.parse(JSON.stringify(this.cancelOrderObj))
      // alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.cancel-work-order')).then(confirm => {
      //   if (confirm) {
      //     const form = {
      //       id: this.woData.id,
      //       status: WO_STATUS_CANCELLED,
      //     }
      //     this.edit(form)
      //   }
      // })


    },
    // 取消工单确认
    cancelOrderConfirm(params) {
      const form = {
        id: this.woData.id,
        status: WO_STATUS_CANCELLED,
        ...params
      }
      // todo: 如果是商机转工单，所写的原因说明和取消原因回填到商机的说明和原因里
      if (this.woData.task_id) {
        patchOpportunity({
          id: this.woData.task_id,
          delay_reason: params.cancel_reason,
          spare_parts_amount: params.spare_parts_amount,
          spare_parts_desc: params.spare_parts_desc,
        })
            .then(() => {
              console.log('回填商机取消原因成功')
            })
            .catch((err) => {
              console.log('回填商机取消原因失败', err)
            });
        postOpportunityComment({
          task: this.woData.task_id,
          content: params.reason_desc,
        })
            .then(() => {
              console.log('回填商机取消说明成功')
            })
            .catch((err) => {
              console.log('回填商机取消说明失败', err)
            });
      }
      this.edit(form, true)
      this.cancelOrderObj.show = false
    },
    // 申请转派
    transferOrder () {
      alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.apply-reassign')).then(confirm => {
        if (confirm) {
          const form = {
            id: this.woData.id,
            status: WO_STATUS_TO_BE_ASSIGNED,
            main_engineer: null,
            assist_engineer: null,
            is_reassign: true,
            is_confirm: false,
            is_checkin: false,
          }
          // 清空签到记录
          // this.checkins.forEach(checkin => {
          //   deleteCheckin(checkin.id)
          // })
          this.edit(form)
        }
      })
    },
    //点击派工确认时,需要校验预计到场时间和预计完工时间
    confirmOrderAfter(){
      if(!this.woData.plan_start_at || !this.woData.plan_end_at){
        //打开子组件确认派工弹框
        this.$refs.basicRef.inspectionTime() 
      }else{
        //如果预计时间填写完整，就派工确认
        this.confirmOrder(false)
      }
    },
    // 派工确认
    confirmOrder(flag) {
      const form = {
          id: this.woData.id,
          status: WO_STATUS_TO_BE_CONSTRUCTED,
          is_confirm: true,
        }
      if(flag){
        this.edit(form)
      }else{
        alertComfirm(this.$t('base.Confirm to perform this operation?'), this.$t('page.dispatch-confirmation')).then(confirm => {
          if (confirm) {
            this.edit(form)
          }
        })
      }
    },
    // 完成工单
    completeOrder () {
      /* 校验服务完成状态 */ 
      if(!this.woData.complete_status){
        errorMsg(this.$t('page.CurrentStatusIsRequired'))
        return;
      }
      alertComfirm( this.$t('page.client_signature')).then(confirm => {
        if (confirm) {
          const form = {
            id: this.woData.id,
            status: WO_STATUS_COMPLETED,
            complete_at: toUtcFormat(moment().format('YYYY-MM-DD HH:mm:ss')),
          }
          this.edit(form)
        }
      })
    },
    edit(params, goBackList = false) {
      editWorkOrder(params).then(() => {
        if (goBackList) {
          setTimeout(() => {
            this.$router.push('/work-order')
          }, 1000);
        } else {
          this.refresh()
        }
      })
    },
  },
  components: {
    CancelModal,
    WoStatusEtc,
    Layout,
    Basic,
    DeviceInfo,
    Logs,
    // Report,
    ReportList
  }
}
</script>
<template>
  <Layout>
    <b-row class="bg-soft-warning px-sm-4 pt-4 mb-sm-4">
      <b-col>
        <b-row>
          <b-col cols="12" md="auto">
            <img v-if="deviceImg" class="rounded-circle" style="width: 80px;height: 80px;" :src="deviceImg">
            <div v-else class="avatar-md">
              <span class="avatar-title rounded-circle bg-soft-primary text-muted font-size-16">
                {{ $t('page.no_image') }}
              </span>
            </div>
          </b-col>
          <b-col>
            <h4 class="mt-0-8">{{woData.number}}</h4>
            <div class="mt-0-8" v-if="woData.service_request">
              {{ $t('page.relatedServiceRequest') }}：
              <router-link
                  :to="'/repair-request/detail/' + woData['service_request']"
              >{{ woData.service_request_number }}</router-link>
            </div>
            <div class="mt-0-8" style="line-height: 2rem;">
              <span class="split-right-border">{{ woData.customer_txt }}</span>
              <span>{{ $t('page.create_time') }}：</span>
              <span class="split-right-border">{{ formatDatetime(woData.created_at) }}</span>
              <!--              <span>{{ $t('page.construction_time') }}：</span>-->
              <!--              <span class="split-right-border">{{ formatDatetime(woData.plan_start_at) }}</span>-->
              <wo-status-etc field-name="priority" :value="woData.priority" custom-class="me-3" custom-style="line-height: 1rem;"  />
              <wo-status-etc field-name="status" :value="woData.status" :wo-data="woData" custom-style="line-height: 1rem;"  />
            </div>
            <div class="mt-0-8" style="line-height: 2rem;" v-if="woData.status == WO_STATUS_CANCELLED">
              <span>{{ $t('page.repair-request.CancelReason') }}：</span>
              <span class="split-right-border">{{ getLabel(woData.cancel_reason) }}</span>
              <span>{{ $t('page.reason_explain') }}：</span>
              <span>{{ woData.reason_desc }}</span>
            </div>
          </b-col>
        </b-row>
      </b-col>
      <b-col cols="12" md="auto" class="text-end">
        <button type="button" v-if="showCancelBtn" class="me-2 mb-2 btn btn-outline-danger" @click="cancelOrder" v-perm="'order.post'">{{ $t('page.cancel_order') }}</button>
        <button type="button" v-if="showTransferBtn" class="me-2 mb-2 btn btn-outline-primary" @click="transferOrder" v-perm="'order.op.transfer'">{{ $t('page.apply_for_transfer') }}</button>
        <button type="button" v-if="showConfirmBtn" class="me-2 mb-2 btn btn-outline-primary" @click="confirmOrderAfter" v-perm="'order.op.confirm'">{{ $t('page.dispatch_confirmation') }}</button> 
        <!-- <button type="button" v-if="showCompleteBtn" class="me-2 mb-2 btn btn-primary" @click="completeOrder" v-perm="'order.other.patch'">{{ $t('page.complete_work_order') }}</button> -->
        <button type="button" v-if="showCompleteBtn" class="me-2 mb-2 btn btn-primary" @click="completeOrder" v-perm="'order.other.patch'">{{ $t('page.client_signature') }}</button>
      </b-col>
      <div class="w-100"></div>
      <b-col>
        <ul class="nav nav-tabs-custom card-header-tabs border-bottom-0 mt-4" role="tablist">
          <li class="nav-item" v-for="(item, index) in tabOptions" :key="index" @click="checkTabVal = item.value">
            <b-link class="nav-link fw-semibold" :class="item.value == checkTabVal ? 'active' : ''" role="tab">
              {{ item.text }}
            </b-link>
          </li>
        </ul>
      </b-col>
    </b-row>
    <div class="bottom-place">
      <Basic ref="basicRef" v-if="detailLoaded&&checkTabVal == '1'" :wo-data="woData" @refresh="refresh" @checkinLoaded="checkinLoaded" @confirmOrder="confirmOrder"/>
      <device-info v-if="detailLoaded" v-show="checkTabVal == '2'" :wo-data="woData" @deviceLoaded="deviceLoaded" />
      <ReportList v-if="detailLoaded" v-show="checkTabVal == '3'" :wo-id="woData.id" :wo-info="woData" :show-search="false" :show-title="false"  />
      <logs v-if="detailLoaded" v-show="checkTabVal == '4'" :wo-data="woData" />
    </div>

    <cancel-modal
        :title="cancelOrderObj.title"
        :type="cancelOrderObj.type"
        :show="cancelOrderObj.show"
        :show-cancel-reason="cancelOrderObj.showCancelReason"
        :cancel-reason-required="cancelOrderObj.cancelReasonRequired"
        @ok="cancelOrderConfirm"
        @cancel="cancelOrderObj.show = false"
    ></cancel-modal>


  </Layout>
</template>
